import React, { Children, useEffect, useState } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  children: string;
  className?: string;
  copiedLabel?: string;
  onClick?: () => void;
};
export const CopyButton = ({ children, className, copiedLabel, onClick, ...rest }: Props) => {
  const [isCopied, setIsCopied] = useState(false);
  useEffect(() => {
    let timer;

    if (isCopied) {
      timer = setTimeout(() => setIsCopied(false), 2000);
    }

    return () => clearTimeout(timer);
  }, [isCopied]);

  if (!Children.count(children)) {
    return null;
  }

  return (
    <div className={classnames('relative isolate inline-flex items-center', className)}>
      <button
        {...rest}
        className="inline-flex items-center gap-5 rounded-pill bg-lightSand px-10 py-2 text-16 font-bold"
        onClick={() => {
          navigator.clipboard.writeText(children);
          onClick?.();
          setIsCopied(true);
        }}
        title={t('booking.common.copyPaste')}
        type="button"
      >
        <Icon name={ICONS.COPY_LINK} />
        {children}
      </button>
      {isCopied && (
        <span className="animation-duration-250 absolute start-full mx-5 flex animate-fadeIn items-center whitespace-nowrap rounded-pill bg-white/80 px-5 py-2 text-12 font-bold text-green">
          <Icon className="shrink-0" name={ICONS.CHECK_FILLED} />
          {copiedLabel}
        </span>
      )}
    </div>
  );
};
